import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { COLOR_MAP } from '../../../constants/ColorNames';
import { Divider } from '@mui/material';

const ArticleSkeleton = () => {
    return (
        <Stack flexGrow={1}>

            <Card>
                <CardContent>
                    <Stack spacing={3}>
                        {Array(2)
                            .fill('')
                            .map((_, i) => (<Stack
                                key={i}
                                spacing={1} direction='row'>
                                <Stack spacing={0.5} width='100%' >
                                    <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width='20%'
                                    />
                                    <Skeleton variant="rectangular" height={30} width='90%' />
                                </Stack>
                                <Stack width='100%' spacing={0.5} >
                                    <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width='20%'
                                    />
                                    <Skeleton variant="rectangular" height={30} width='70%' />
                                </Stack>
                                <Stack width='100%' spacing={0.5} >
                                    <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width='20%'
                                    />
                                    <Skeleton variant="rectangular" height={30} width='70%' />
                                </Stack>
                            </Stack>
                            ))
                        }
                        <Stack spacing={1} direction='row'>
                            {Array(2).fill('')
                                .map((_, i) => (
                                    <Stack key={i} spacing={0.5} width='100%' >
                                        <Skeleton
                                            animation="wave"
                                            variant="text"
                                            width='20%'
                                        />
                                        <Skeleton variant="rectangular" height={30} width='90%' />
                                    </Stack>

                                ))}

                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
            <Card style={{ marginTop: '1rem' }}>
                <CardContent>
                    <Stack spacing={2}>
                        <Stack
                            divider={<Divider orientation="vertical" flexItem />}
                            spacing={1}
                            direction='row'>
                            {Array(3).fill('')
                                .map((_, i) => (

                                    <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width='10%'
                                        height={50}
                                    />

                                ))}
                        </Stack>

                        <Stack
                            alignItems='center'
                            spacing={1}
                            direction='row'>
                            <Stack width='100%'>
                                <Skeleton
                                    animation="wave"
                                    variant="text"
                                    width='30%'
                                />
                            </Stack>
                            <Stack width='100%'
                                direction='row'
                                justifyContent='space-between'>
                                <Stack width='100%'>
                                    <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width='30%'
                                        height={30}

                                    />
                                </Stack>
                                <Stack width='100%' direction='row' spacing={1}>
                                    <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width='30%'
                                        height={30}
                                    />
                                </Stack>
                            </Stack>
                        </Stack>

                        <Stack>
                            <Skeleton
                                animation="wave"
                                variant="rectangular"
                                height={200}
                            />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </Stack >
    );
};

export default ArticleSkeleton;
